import { API_BASE_URL } from '../config/api';
import { parseApiResponse } from './apiHelpers';

const REVIEWS_BASE = `${API_BASE_URL}/reviews`;
const AUTH_BASE = `${API_BASE_URL}/auth`;

export const fetchApprovedReviews = async () => {
  const res = await fetch(`${REVIEWS_BASE}/approved`);
  const data = await parseApiResponse(res);
  return data.data;
};

export const submitReview = async ({ name, rating, comment }) => {
  const res = await fetch(REVIEWS_BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, rating, comment }),
  });
  return parseApiResponse(res);
};

export const adminLogin = async ({ username, password }) => {
  const res = await fetch(`${AUTH_BASE}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  const data = await parseApiResponse(res);
  return data.data;
};

export const verifyAdminToken = async (authHeaders) => {
  const res = await fetch(`${AUTH_BASE}/verify`, { headers: authHeaders });
  if (!res.ok) {
    throw new Error('Token invalid');
  }
  return parseApiResponse(res);
};

export const fetchAllReviews = async (authHeaders) => {
  const res = await fetch(`${REVIEWS_BASE}/all`, { headers: authHeaders });
  const data = await parseApiResponse(res);
  return data.data;
};

export const fetchReviewStats = async (authHeaders) => {
  const res = await fetch(`${REVIEWS_BASE}/stats`, { headers: authHeaders });
  const data = await parseApiResponse(res);
  return data.data;
};

export const approveReview = async (reviewId, authHeaders) => {
  const res = await fetch(`${REVIEWS_BASE}/${reviewId}/approve`, {
    method: 'PATCH',
    headers: authHeaders,
  });
  return parseApiResponse(res);
};

export const deleteReview = async (reviewId, authHeaders) => {
  const res = await fetch(`${REVIEWS_BASE}/${reviewId}`, {
    method: 'DELETE',
    headers: authHeaders,
  });
  return parseApiResponse(res);
};
